import { fetchAPI } from "@/lib/fetch-api";

// Public API - No token required
export async function getProvinces() {
  const path = `/teamleader/level-two-area-addresses`;
  const urlParamsObject = { populate: ["deep"] };
  const options = {};
  return await fetchAPI(path, urlParamsObject, options);
}
